import { useSearchParams, useLoaderData } from "react-router-dom";

import { PayPalScriptProvider } from "@paypal/react-paypal-js";

import { fetchAdamo } from "../utils/fetchAdamo.js";
import { OrderExpired } from "./NotificationPages/OrderExpired.jsx";
import { OrderNotFound } from "./NotificationPages/OrderNotFound.jsx";
import { AlreadyPayed } from "./NotificationPages/AlreadyPayed.jsx";
import { Payment } from "./Payment.jsx";

export async function getEmailValidation({params}){
    let orderId = (params['orderId']).toString();
    let order = {"orderId":orderId};
    let response = await fetchAdamo("/ajax/kezdolap/validate-order", "POST", order);

    return response.json();            
}

export function EmaillValidation(){    
    const initialOptions = {
        "client-id": "Abgn41eSzxeWM7sid9sKhZB1ij-qcwKy_RrtUkIsxx4C5jPV0aFLzslvtdUY_mh2f3QycFjq8GRdH36t",
        "enable-funding": "card",
        "disable-funding": "paylater,venmo",
        "data-sdk-integration-source": "integrationbuilder_sc",
        "currency":"HUF"
      };

    let order = useLoaderData();

    console.log("[EmaillValidation] order: ");
    console.log(order);

    let errorCode = order['error_code'];
    let isExpired = order['is_expired'];
    let isPayed = order['payed'];
    console.log('errorCode: '+errorCode);

    if (errorCode===0) {
        if (isPayed==='0') {
            if (!isExpired) {
                return (
                    <PayPalScriptProvider options={initialOptions}>
                        <div>
                            <Payment order={order}/>
                        </div>
                    </PayPalScriptProvider>
                )
            }
            else {
                return (
                    <div>
                        <OrderExpired/>
                    </div>
                )
            }
        }
        else {
            return (
                 <div>
                    <AlreadyPayed/>
                 </div>
            )
        }
    }
    else {
        return (
            <div>
                <OrderNotFound/>
            </div>
        )
    }
}
